module.exports = __webpack_public_path__ + "assets/e796acaefe719180aa151d9362318ad8.png";